import { type FC } from 'react';

export interface CardContainerProps {
    cols?: '1' | '2' | '3' | '4' | '5' | '6';
    singleColumnOnTablet?: boolean;
    className?: string;
    children: React.ReactNode;
}

const CardContainer: FC<CardContainerProps> = ({
    className = '',
    children,
    cols = 3,
    singleColumnOnTablet,
}) => {
    return (
        <div className={`card-container cols-${cols} ${singleColumnOnTablet ? 'cols-md-1' : ''} ${className}`}>
            {children}
        </div>
    );
};

export default CardContainer;
